import React, { useEffect } from 'react';
import { translations } from '../Text/translations';
import msgDialogIcon from '../../assets/icons/msg-dialog.svg';
import phoneCallIcon from '../../assets/icons/phone-call.svg';
import disneyActivationEn from '../../assets/disneyplus/DisneyPlus_Activation_visual_en.png';
import disneyActivationTc from '../../assets/disneyplus/DisneyPlus_Activation_visual_tc.png';

const DisneyPlusEnquiry = ({ currentLang, nickname, mobilenowid, emailnowid, fsa, learnMoreUrl }) => {
  const handleLearnMoreButtonClick = () => {
    window.location.href = learnMoreUrl;
  };

  return (
    <>
      <div className="name">
        <h2 className="name">{translations[currentLang].disneyplusSubjectGreeting}{nickname || mobilenowid || emailnowid}{translations[currentLang].disneyplusSubjectGreeting2}</h2>
      </div>

      <div className="message">
        <p>{translations[currentLang].disneyplusNoBundle}</p>
      </div>

      <div className="cta-buttons">
        <p><b>{translations[currentLang].disneyplusNotSubscribedYet}</b></p>
        <button className="btn primary" onClick={handleLearnMoreButtonClick}>
          {translations[currentLang].learnMoreAboutDisneyplusPlans}
        </button>
      </div>

      <div className="need-help">
        <h5>{translations[currentLang].disneyplusNeedHelp}</h5>
        <div className="chat-options">
          <div className="item">
            <a href="https://api.whatsapp.com/send?phone=85296133533" target="_blank">
                <div className="img-wrap"><img src={msgDialogIcon} alt="" className="message" /></div>
               <h4>WhatsApp</h4>
             </a>
          </div>
          <div className="item">
            <a href={`tel:${currentLang === 'en' ? '28880008' : '28881888'}`}>
              <div className="img-wrap"><img src={phoneCallIcon} alt="" className="phone" /></div>
              <h4>{currentLang === 'en' ? '2888 0008' : '2888 1888'}</h4>
            </a>
          </div>
        </div>
      </div>

      <div className="preview-img">
        <img src={currentLang === 'en' ? disneyActivationEn : disneyActivationTc} alt="" />
      </div>
    </>
  );
};

export default DisneyPlusEnquiry;